import { defineComponent } from 'vue';
import { cogOutline, menu } from 'ionicons/icons';
import { IonIcon, IonButton, IonToolbar, IonMenuToggle, IonTitle, IonButtons, } from '@ionic/vue';
import PageTitle from "@/components/app-structure/PageTitle.vue";
export default defineComponent({
    props: {
        logo: Boolean,
        title: String,
        settingsButton: { type: Boolean, default: true },
        backButton: { type: Boolean, default: false },
        backButtonText: String,
        backButtonTo: { type: String, default: '/' }
    },
    setup() {
        return {
            cogOutline, menu
        };
    },
    components: {
        PageTitle,
        IonIcon,
        IonButton,
        IonToolbar,
        IonMenuToggle,
        IonTitle,
        IonButtons,
    }
});
